import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "gatsby-plugin-react-i18next";
import { Breadcrumb } from "./Breadcrumb";

type BreadcrumbsWrapperProps = {
  items: Breadcrumb[];
};
const BreadcrumbsWrapper = ({ items }: BreadcrumbsWrapperProps) => {
  return (
    <Breadcrumbs separator="›" aria-label="breadcrumb">
      {items.map((item, key) =>
        item.isActive ? (
          <Typography key={key}>{item.label}</Typography>
        ) : (
          <Link
            key={key}
            to={item.link!}
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            {item.label}
          </Link>
        )
      )}
    </Breadcrumbs>
  );
};

export default BreadcrumbsWrapper;
